import { Opportunity } from "../opportunity";
import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { CallCenterShift } from "../call-center-shift";
import { CallCenterShiftTaskEntityConfig } from "./config";
import { CallCenterShiftTaskFilters } from "./filters";
import { CallCenterShiftTaskMethods } from "./methods";

@HyperEntity<CallCenterShiftTask>(
  "call-center-shift-task",
  CallCenterShiftTaskEntityConfig,
)
export class CallCenterShiftTask extends extender(
  CallCenterShiftTaskFilters,
  CallCenterShiftTaskMethods,
) {
  @Fields.id()
  id = "";

  @Fields.string({ dbName: "shift_id", caption: "משמרת" })
  shiftId = "";

  @Relations.toOne(() => CallCenterShift, "shiftId")
  shift?: CallCenterShift;

  @Fields.string({ dbName: "opportunity_id", caption: "משימה" })
  opportunityId = "";

  @Relations.toOne(() => Opportunity, "opportunityId")
  opportunity?: Opportunity;

  @Fields.date({ dbName: "started_at", caption: "התחלה" })
  startedAt = new Date();

  @Fields.date({ dbName: "completed_at", allowNull: true, caption: "הושלמה" })
  completedAt?: Date;

  @Fields.boolean({ dbName: "treated_for_day", caption: "טופלה להיום" })
  treatedForDay = false;

  @Fields.date({
    dbName: "leave_requested_at",
    allowNull: true,
    caption: "בקשת יציאה",
  })
  leaveRequestedAt?: Date;

  @Fields.string({ dbName: "leave_reason", allowNull: true, caption: "סיבת יציאה" })
  leaveReason?: string;

  @Fields.date({
    dbName: "coordinator_approved_at",
    allowNull: true,
    caption: "אושר על ידי רכז",
  })
  coordinatorApprovedAt?: Date;

  @Fields.integer({ dbName: "matches_on_task", caption: "מאצ'ים במשימה" })
  matchesOnTask = 0;

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
